import { useState } from "react"

import "./FormSystemUser.css"
import api from '../../../utils/api'
/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'
/* form */
import Input from "../../../shared/components/form/input"
import Checkbox from "../../../shared/components/form/checkbox"
import ToggleSwitch from "../../../shared/components/form/ToggleSwitch"
import Modal from "../../../shared/modal/Modal"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"

//icon
import { PiCheckCircleFill } from "react-icons/pi"
import { MdRadioButtonUnchecked } from "react-icons/md"

//img
import client from "../img/client.jpg"
import provider from "../img/provider.jpg"
import cloth from "../img/cloth.jpg"
import category from "../img/category.jpg"
import grade from "../img/grade.jpg"
import commission from "../img/commission.jpg"
import product from "../img/product.jpg"
import color from "../img/color.jpg"
import additive from "../img/additive.jpg"
import accessory from "../img/accessory.jpg"
import budget from "../img/budget.jpg"
import backup from "../img/backup.jpg"
import historic from "../img/historic.jpg"
import generator from "../img/generator.jpg"

function FormSystemUser({ handleSubmit, userData, btnText, btCancelAction, title, changePassword, userPermission, permissionData, mode = 'both' }) {
  const [myPermission] = useState(permissionData || {})
  const [user, setUser] = useState(userData || {})
  const [permission, setPermission] = useState(userPermission || { group: "user" })
  const [newPwd, setNewPwd] = useState({})
  const [selectedTab, setSelectedTab] = useState(mode === 'permission' ? 'permission' : 'user')

  const showInfo = mode === 'both' ? selectedTab === 'user' : mode === 'info'
  const showPermission = mode === 'both' ? selectedTab === 'permission' : mode === 'permission'

  const [modalChangePwd, setModalChangePwd] = useState(false)
  const [token] = useState(localStorage.getItem('token') || '')
  const { setFlashMessage } = useFlashMessage()

  //password validation states
  const [lowerValidated, setLowerValidated] = useState(false)
  const [upperValidated, setUpperValidated] = useState(false)
  const [numberValidated, setNumberValidated] = useState(false)
  const [specialValidated, setSpecialValidated] = useState(false)
  const [lengthValidated, setLengthValidated] = useState(false)

  const handleChangePwd = (e) => {
    const value = e.target.value
    setUser(prev => ({ ...prev, [e.target.name]: value }))
    validatePwd(value)
  }

  const handleChangePermission = (e) => {
    setPermission(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleChangeTS = (name, value) => {
    setPermission(prev => ({ ...prev, [name]: value }))
  }

  const handleChangeNewPwd = (e) => {
    const value = e.target.value
    setNewPwd(prev => ({ ...prev, [e.target.name]: value }))
    if (e.target.name !== "confirmPassword") {
      validatePwd(value)
    }
  }

  function validatePwd(pwd) {
    const lower = new RegExp('(?=.*[a-z])')
    const upper = new RegExp('(?=.*[A-Z])')
    const number = new RegExp('(?=.*[0-9])')
    const special = new RegExp('(?=.*[!@#\$%\^&\*])')
    const length = new RegExp('(?=.{8,})')

    setLowerValidated(lower.test(pwd))
    setUpperValidated(upper.test(pwd))
    setNumberValidated(number.test(pwd))
    setSpecialValidated(special.test(pwd))
    setLengthValidated(length.test(pwd))
  }

  function handleChange(e) {
    setUser(prev => ({ ...prev, [e.target.name]: e.target.value }))
  }

  function handleChangeCheckbox(name, value) {
    setUser(prev => ({ ...prev, [name]: value }))
  }

  async function submitChangePwd() {
    let msgType = 'success'

    const data = await api.patch(`/user/changepwd/${user._id}`, newPwd, {
      headers: { Authorization: `Bearer ${JSON.parse(token)}` }
    }).then((response) => {
      setModalChangePwd(false)
      return response.data
    }).catch((err) => {
      msgType = 'error'
      return err.response.data
    })

    setFlashMessage(data.message, msgType)
  }

  function submit(e) {
    e.preventDefault()
    handleSubmit({ ...user, permission })
  }

  const PwdValidationList = () => (
    <div className="validation-box form-group">
      <div className={upperValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{upperValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos uma letra maiúscula</div>
      <div className={lowerValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{lowerValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos uma letra minúscula</div>
      <div className={numberValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{numberValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos um número</div>
      <div className={specialValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{specialValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos um caractere especial</div>
      <div className={lengthValidated ? "validation-item-true" : "validation-item-false"}><div className="validation-item-icon">{lengthValidated ? <PiCheckCircleFill /> : <MdRadioButtonUnchecked />}</div>Pelo menos 8 caracteres</div>
    </div>
  )

  return (
    <>
      <FormLayout
        title={title}
        onSubmit={submit}
        actions={
          <>
            <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
            {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
          </>
        }
      >
        {mode === 'both' && (
          <div className="su-tab-row">
            <button type="button" className={`su-tab ${selectedTab === "user" ? "su-tab-active" : ""}`} onClick={() => setSelectedTab("user")}>
              Usuário
            </button>
            <button type="button" className={`su-tab ${selectedTab === "permission" ? "su-tab-active" : ""}`} onClick={() => setSelectedTab("permission")}>
              Permissões
            </button>
          </div>
        )}

        {showInfo && (
          <FormSection label="Dados do Usuário">
            {changePassword !== 'disable' && (
              <div className="form-group">
                <Checkbox
                  text="Usuário desabilitado"
                  name="disabledUser"
                  handleOnChange={() => handleChangeCheckbox("disabledUser", !user.disabledUser)}
                  check={user.disabledUser || false}
                />
              </div>
            )}

            <div className="fl-row">
              <div className="fl-col-wide form-group">
                <Input text="Nome completo" type="text" name="name" placeholder="Digite o nome do usuário" handleOnChange={handleChange} value={user.name || ''} />
              </div>
              <div className="fl-col-mid form-group">
                <Input text="E-mail" type="email" name="email" placeholder="Digite o e-mail" handleOnChange={handleChange} value={user.email || ''} />
              </div>
            </div>

            <div className="fl-row">
              <div className="fl-col-mid form-group">
                <Input text="Data de Nascimento" type="date" name="birth" handleOnChange={handleChange} value={user.birth || ''} />
              </div>
              <div className="fl-col-mid form-group">
                <Input text="Telefone WhatsApp" type="tel" name="phone" placeholder="Digite o telefone" handleOnChange={handleChange} value={user.phone || ''} />
              </div>
              <div className="fl-col-mid form-group">
                <Input text="Usuário" type="text" name="userName" placeholder="Usuário de acesso" handleOnChange={handleChange} value={user.userName || ''} />
              </div>
            </div>

            {changePassword === 'disable' ? (
              <>
                <div className="fl-row">
                  <div className="fl-col-mid form-group">
                    <Input text="Senha" type="password" name="password" placeholder="Digite a senha" handleOnChange={handleChangePwd} value={user.password || ''} />
                  </div>
                  <div className="fl-col-mid form-group">
                    <Input text="Confirmar senha" type="password" name="confirmPassword" placeholder="Repita a senha" handleOnChange={handleChange} value={user.confirmPassword || ''} />
                  </div>
                </div>
                <PwdValidationList />
              </>
            ) : (
              <div className="form-group">
                <Button variant="edit" onClick={() => setModalChangePwd(true)}>Alterar senha</Button>
              </div>
            )}

            {myPermission.group === "DEV_MASTER" && (
              <div className="fl-row">
                <div className="fl-col-mid form-group">
                  <Input text="Grupo" type="text" name="group" placeholder="Digite o grupo de acesso" handleOnChange={handleChangePermission} value={permission.group || ''} />
                </div>
              </div>
            )}
          </FormSection>
        )}

        {showPermission && (
          <>
            <FormSection label="Clientes">
              <div className="su-permission-box">
                <img className="su-permission-img" src={client} alt="" />
                <div className="su-permission-content">
                  <p className="su-permission-title">Clientes</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="client_view" value={permission.client_view} handleOnChange={() => handleChangeTS("client_view", !permission.client_view)} />
                    <ToggleSwitch text="Criar" name="client_create" value={permission.client_create} handleOnChange={() => handleChangeTS("client_create", !permission.client_create)} />
                    <ToggleSwitch text="Editar" name="client_edit" value={permission.client_edit} handleOnChange={() => handleChangeTS("client_edit", !permission.client_edit)} />
                    <ToggleSwitch text="Excluir" name="client_delete" value={permission.client_delete} handleOnChange={() => handleChangeTS("client_delete", !permission.client_delete)} />
                  </div>
                  <hr className="su-permission-divider" />
                  <p className="su-permission-title">Meus Clientes</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="myClient_view" value={permission.myClient_view} handleOnChange={() => handleChangeTS("myClient_view", !permission.myClient_view)} />
                    <ToggleSwitch text="Criar" name="myClient_create" value={permission.myClient_create} handleOnChange={() => handleChangeTS("myClient_create", !permission.myClient_create)} />
                    <ToggleSwitch text="Editar" name="myClient_edit" value={permission.myClient_edit} handleOnChange={() => handleChangeTS("myClient_edit", !permission.myClient_edit)} />
                    <ToggleSwitch text="Excluir" name="myClient_delete" value={permission.myClient_delete} handleOnChange={() => handleChangeTS("myClient_delete", !permission.myClient_delete)} />
                  </div>
                </div>
              </div>
            </FormSection>

            <FormSection label="Fornecedores">
              <div className="su-permission-box">
                <img className="su-permission-img" src={provider} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="provider_view" value={permission.provider_view} handleOnChange={() => handleChangeTS("provider_view", !permission.provider_view)} />
                  <ToggleSwitch text="Criar" name="provider_create" value={permission.provider_create} handleOnChange={() => handleChangeTS("provider_create", !permission.provider_create)} />
                  <ToggleSwitch text="Editar" name="provider_edit" value={permission.provider_edit} handleOnChange={() => handleChangeTS("provider_edit", !permission.provider_edit)} />
                  <ToggleSwitch text="Excluir" name="provider_delete" value={permission.provider_delete} handleOnChange={() => handleChangeTS("provider_delete", !permission.provider_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Tecidos">
              <div className="su-permission-box">
                <img className="su-permission-img" src={cloth} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="cloth_view" value={permission.cloth_view} handleOnChange={() => handleChangeTS("cloth_view", !permission.cloth_view)} />
                  <ToggleSwitch text="Criar" name="cloth_create" value={permission.cloth_create} handleOnChange={() => handleChangeTS("cloth_create", !permission.cloth_create)} />
                  <ToggleSwitch text="Editar" name="cloth_edit" value={permission.cloth_edit} handleOnChange={() => handleChangeTS("cloth_edit", !permission.cloth_edit)} />
                  <ToggleSwitch text="Excluir" name="cloth_delete" value={permission.cloth_delete} handleOnChange={() => handleChangeTS("cloth_delete", !permission.cloth_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Aviamentos">
              <div className="su-permission-box">
                <img className="su-permission-img" src={cloth} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="aviamento_view" value={permission.aviamento_view} handleOnChange={() => handleChangeTS("aviamento_view", !permission.aviamento_view)} />
                  <ToggleSwitch text="Criar" name="aviamento_create" value={permission.aviamento_create} handleOnChange={() => handleChangeTS("aviamento_create", !permission.aviamento_create)} />
                  <ToggleSwitch text="Editar" name="aviamento_edit" value={permission.aviamento_edit} handleOnChange={() => handleChangeTS("aviamento_edit", !permission.aviamento_edit)} />
                  <ToggleSwitch text="Excluir" name="aviamento_delete" value={permission.aviamento_delete} handleOnChange={() => handleChangeTS("aviamento_delete", !permission.aviamento_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Categorias">
              <div className="su-permission-box">
                <img className="su-permission-img" src={category} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="category_view" value={permission.category_view} handleOnChange={() => handleChangeTS("category_view", !permission.category_view)} />
                  <ToggleSwitch text="Criar" name="category_create" value={permission.category_create} handleOnChange={() => handleChangeTS("category_create", !permission.category_create)} />
                  <ToggleSwitch text="Editar" name="category_edit" value={permission.category_edit} handleOnChange={() => handleChangeTS("category_edit", !permission.category_edit)} />
                  <ToggleSwitch text="Excluir" name="category_delete" value={permission.category_delete} handleOnChange={() => handleChangeTS("category_delete", !permission.category_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Grade de Tamanhos">
              <div className="su-permission-box">
                <img className="su-permission-img" src={grade} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="sizeGrid_view" value={permission.sizeGrid_view} handleOnChange={() => handleChangeTS("sizeGrid_view", !permission.sizeGrid_view)} />
                  <ToggleSwitch text="Criar" name="sizeGrid_create" value={permission.sizeGrid_create} handleOnChange={() => handleChangeTS("sizeGrid_create", !permission.sizeGrid_create)} />
                  <ToggleSwitch text="Editar" name="sizeGrid_edit" value={permission.sizeGrid_edit} handleOnChange={() => handleChangeTS("sizeGrid_edit", !permission.sizeGrid_edit)} />
                  <ToggleSwitch text="Excluir" name="sizeGrid_delete" value={permission.sizeGrid_delete} handleOnChange={() => handleChangeTS("sizeGrid_delete", !permission.sizeGrid_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Comissão e Desconto">
              <div className="su-permission-box">
                <img className="su-permission-img" src={commission} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="commission_view" value={permission.commission_view} handleOnChange={() => handleChangeTS("commission_view", !permission.commission_view)} />
                  <ToggleSwitch text="Criar" name="commission_create" value={permission.commission_create} handleOnChange={() => handleChangeTS("commission_create", !permission.commission_create)} />
                  <ToggleSwitch text="Editar" name="commission_edit" value={permission.commission_edit} handleOnChange={() => handleChangeTS("commission_edit", !permission.commission_edit)} />
                  <ToggleSwitch text="Excluir" name="commission_delete" value={permission.commission_delete} handleOnChange={() => handleChangeTS("commission_delete", !permission.commission_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Produtos">
              <div className="su-permission-box">
                <img className="su-permission-img" src={product} alt="" />
                <div className="su-permission-content">
                  <p className="su-permission-title">Produtos</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="product_view" value={permission.product_view} handleOnChange={() => handleChangeTS("product_view", !permission.product_view)} />
                    <ToggleSwitch text="Criar" name="product_create" value={permission.product_create} handleOnChange={() => handleChangeTS("product_create", !permission.product_create)} />
                    <ToggleSwitch text="Editar" name="product_edit" value={permission.product_edit} handleOnChange={() => handleChangeTS("product_edit", !permission.product_edit)} />
                    <ToggleSwitch text="Excluir" name="product_delete" value={permission.product_delete} handleOnChange={() => handleChangeTS("product_delete", !permission.product_delete)} />
                  </div>
                  <hr className="su-permission-divider" />
                  <p className="su-permission-title">Produtos Simples</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="simpleProduct_view" value={permission.simpleProduct_view} handleOnChange={() => handleChangeTS("simpleProduct_view", !permission.simpleProduct_view)} />
                    <ToggleSwitch text="Criar" name="simpleProduct_create" value={permission.simpleProduct_create} handleOnChange={() => handleChangeTS("simpleProduct_create", !permission.simpleProduct_create)} />
                    <ToggleSwitch text="Editar" name="simpleProduct_edit" value={permission.simpleProduct_edit} handleOnChange={() => handleChangeTS("simpleProduct_edit", !permission.simpleProduct_edit)} />
                    <ToggleSwitch text="Excluir" name="simpleProduct_delete" value={permission.simpleProduct_delete} handleOnChange={() => handleChangeTS("simpleProduct_delete", !permission.simpleProduct_delete)} />
                  </div>
                </div>
              </div>
            </FormSection>

            <FormSection label="Cores">
              <div className="su-permission-box">
                <img className="su-permission-img" src={color} alt="" />
                <div className="su-permission-content">
                  <p className="su-permission-title">Cores</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="color_view" value={permission.color_view} handleOnChange={() => handleChangeTS("color_view", !permission.color_view)} />
                    <ToggleSwitch text="Criar" name="color_create" value={permission.color_create} handleOnChange={() => handleChangeTS("color_create", !permission.color_create)} />
                    <ToggleSwitch text="Editar" name="color_edit" value={permission.color_edit} handleOnChange={() => handleChangeTS("color_edit", !permission.color_edit)} />
                    <ToggleSwitch text="Excluir" name="color_delete" value={permission.color_delete} handleOnChange={() => handleChangeTS("color_delete", !permission.color_delete)} />
                  </div>
                  <hr className="su-permission-divider" />
                  <p className="su-permission-title">Tipos de Cores</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="colorType_view" value={permission.colorType_view} handleOnChange={() => handleChangeTS("colorType_view", !permission.colorType_view)} />
                    <ToggleSwitch text="Criar" name="colorType_create" value={permission.colorType_create} handleOnChange={() => handleChangeTS("colorType_create", !permission.colorType_create)} />
                    <ToggleSwitch text="Editar" name="colorType_edit" value={permission.colorType_edit} handleOnChange={() => handleChangeTS("colorType_edit", !permission.colorType_edit)} />
                    <ToggleSwitch text="Excluir" name="colorType_delete" value={permission.colorType_delete} handleOnChange={() => handleChangeTS("colorType_delete", !permission.colorType_delete)} />
                  </div>
                </div>
              </div>
            </FormSection>

            <FormSection label="Aditivos">
              <div className="su-permission-box">
                <img className="su-permission-img" src={additive} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="additive_view" value={permission.additive_view} handleOnChange={() => handleChangeTS("additive_view", !permission.additive_view)} />
                  <ToggleSwitch text="Criar" name="additive_create" value={permission.additive_create} handleOnChange={() => handleChangeTS("additive_create", !permission.additive_create)} />
                  <ToggleSwitch text="Editar" name="additive_edit" value={permission.additive_edit} handleOnChange={() => handleChangeTS("additive_edit", !permission.additive_edit)} />
                  <ToggleSwitch text="Excluir" name="additive_delete" value={permission.additive_delete} handleOnChange={() => handleChangeTS("additive_delete", !permission.additive_delete)} />
                  <ToggleSwitch text="Ver Custo/Lucro" name="additive_viewCost" value={permission.additive_viewCost} handleOnChange={() => handleChangeTS("additive_viewCost", !permission.additive_viewCost)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Acessórios">
              <div className="su-permission-box">
                <img className="su-permission-img" src={accessory} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="accessory_view" value={permission.accessory_view} handleOnChange={() => handleChangeTS("accessory_view", !permission.accessory_view)} />
                  <ToggleSwitch text="Criar" name="accessory_create" value={permission.accessory_create} handleOnChange={() => handleChangeTS("accessory_create", !permission.accessory_create)} />
                  <ToggleSwitch text="Editar" name="accessory_edit" value={permission.accessory_edit} handleOnChange={() => handleChangeTS("accessory_edit", !permission.accessory_edit)} />
                  <ToggleSwitch text="Excluir" name="accessory_delete" value={permission.accessory_delete} handleOnChange={() => handleChangeTS("accessory_delete", !permission.accessory_delete)} />
                  <ToggleSwitch text="Ver Custo/Lucro" name="accessory_viewCost" value={permission.accessory_viewCost} handleOnChange={() => handleChangeTS("accessory_viewCost", !permission.accessory_viewCost)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Orçamento">
              <div className="su-permission-box">
                <img className="su-permission-img" src={budget} alt="" />
                <div className="su-permission-content">
                  <p className="su-permission-title">Orçamentos</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="budget_view" value={permission.budget_view} handleOnChange={() => handleChangeTS("budget_view", !permission.budget_view)} />
                    <ToggleSwitch text="Criar" name="budget_create" value={permission.budget_create} handleOnChange={() => handleChangeTS("budget_create", !permission.budget_create)} />
                    <ToggleSwitch text="Editar" name="budget_edit" value={permission.budget_edit} handleOnChange={() => handleChangeTS("budget_edit", !permission.budget_edit)} />
                    <ToggleSwitch text="Excluir" name="budget_delete" value={permission.budget_delete} handleOnChange={() => handleChangeTS("budget_delete", !permission.budget_delete)} />
                    <ToggleSwitch text="Configurar Orçamento" name="budget_config" value={permission.budget_config} handleOnChange={() => handleChangeTS("budget_config", !permission.budget_config)} />
                    <ToggleSwitch text="Editar comissão e desconto" name="budget_commission_edit" value={permission.budget_commission_edit} handleOnChange={() => handleChangeTS("budget_commission_edit", !permission.budget_commission_edit)} />
                    <ToggleSwitch text="Editar vendedor" name="budget_editSeller" value={permission.budget_editSeller} handleOnChange={() => handleChangeTS("budget_editSeller", !permission.budget_editSeller)} />
                  </div>
                  <div className="su-instalment-limit">
                    <Input text="Limite de Parcelas" type="number" name="budget_maxInstalment" placeholder="1" handleOnChange={handleChangePermission} value={permission.budget_maxInstalment || ''} />
                    <span className="su-instalment-limit-hint">Máximo de parcelas que esse usuário pode oferecer no orçamento. Vazio ou 1 = somente à vista.</span>
                  </div>
                  <hr className="su-permission-divider" />
                  <p className="su-permission-title">Meus Orçamentos</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="myBudget_view" value={permission.myBudget_view} handleOnChange={() => handleChangeTS("myBudget_view", !permission.myBudget_view)} />
                    <ToggleSwitch text="Criar" name="myBudget_create" value={permission.myBudget_create} handleOnChange={() => handleChangeTS("myBudget_create", !permission.myBudget_create)} />
                    <ToggleSwitch text="Editar" name="myBudget_edit" value={permission.myBudget_edit} handleOnChange={() => handleChangeTS("myBudget_edit", !permission.myBudget_edit)} />
                    <ToggleSwitch text="Excluir" name="myBudget_delete" value={permission.myBudget_delete} handleOnChange={() => handleChangeTS("myBudget_delete", !permission.myBudget_delete)} />
                  </div>
                </div>
              </div>
            </FormSection>

            <FormSection label="Pedido">
              <div className="su-permission-box">
                <img className="su-permission-img" src={budget} alt="" />
                <div className="su-permission-content">
                  <p className="su-permission-title">Pedidos</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="order_view" value={permission.order_view} handleOnChange={() => handleChangeTS("order_view", !permission.order_view)} />
                    <ToggleSwitch text="Criar" name="order_create" value={permission.order_create} handleOnChange={() => handleChangeTS("order_create", !permission.order_create)} />
                    <ToggleSwitch text="Editar" name="order_edit" value={permission.order_edit} handleOnChange={() => handleChangeTS("order_edit", !permission.order_edit)} />
                    <ToggleSwitch text="Excluir" name="order_delete" value={permission.order_delete} handleOnChange={() => handleChangeTS("order_delete", !permission.order_delete)} />
                  </div>
                  <hr className="su-permission-divider" />
                  <p className="su-permission-title">Meus Pedidos</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="myOrder_view" value={permission.myOrder_view} handleOnChange={() => handleChangeTS("myOrder_view", !permission.myOrder_view)} />
                    <ToggleSwitch text="Criar" name="myOrder_create" value={permission.myOrder_create} handleOnChange={() => handleChangeTS("myOrder_create", !permission.myOrder_create)} />
                    <ToggleSwitch text="Editar" name="myOrder_edit" value={permission.myOrder_edit} handleOnChange={() => handleChangeTS("myOrder_edit", !permission.myOrder_edit)} />
                    <ToggleSwitch text="Excluir" name="myOrder_delete" value={permission.myOrder_delete} handleOnChange={() => handleChangeTS("myOrder_delete", !permission.myOrder_delete)} />
                  </div>
                  <hr className="su-permission-divider" />
                  <p className="su-permission-title">Lucro / Margem do Pedido</p>
                  <div className="su-toggle-grid">
                    <ToggleSwitch text="Visualizar" name="order_viewMargin" value={permission.order_viewMargin} handleOnChange={() => handleChangeTS("order_viewMargin", !permission.order_viewMargin)} />
                  </div>
                </div>
              </div>
            </FormSection>

            <FormSection label="Estoque">
              <div className="su-permission-box">
                <img className="su-permission-img" src={cloth} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="stock_view" value={permission.stock_view} handleOnChange={() => handleChangeTS("stock_view", !permission.stock_view)} />
                  <ToggleSwitch text="Criar" name="stock_create" value={permission.stock_create} handleOnChange={() => handleChangeTS("stock_create", !permission.stock_create)} />
                  <ToggleSwitch text="Editar" name="stock_edit" value={permission.stock_edit} handleOnChange={() => handleChangeTS("stock_edit", !permission.stock_edit)} />
                  <ToggleSwitch text="Excluir" name="stock_delete" value={permission.stock_delete} handleOnChange={() => handleChangeTS("stock_delete", !permission.stock_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Estoque Geral">
              <div className="su-permission-box">
                <img className="su-permission-img" src={cloth} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="stockGeneral_view" value={permission.stockGeneral_view} handleOnChange={() => handleChangeTS("stockGeneral_view", !permission.stockGeneral_view)} />
                  <ToggleSwitch text="Criar" name="stockGeneral_create" value={permission.stockGeneral_create} handleOnChange={() => handleChangeTS("stockGeneral_create", !permission.stockGeneral_create)} />
                  <ToggleSwitch text="Editar" name="stockGeneral_edit" value={permission.stockGeneral_edit} handleOnChange={() => handleChangeTS("stockGeneral_edit", !permission.stockGeneral_edit)} />
                  <ToggleSwitch text="Excluir" name="stockGeneral_delete" value={permission.stockGeneral_delete} handleOnChange={() => handleChangeTS("stockGeneral_delete", !permission.stockGeneral_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Compras">
              <div className="su-permission-box">
                <img className="su-permission-img" src={provider} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="purchase_view" value={permission.purchase_view} handleOnChange={() => handleChangeTS("purchase_view", !permission.purchase_view)} />
                  <ToggleSwitch text="Criar" name="purchase_create" value={permission.purchase_create} handleOnChange={() => handleChangeTS("purchase_create", !permission.purchase_create)} />
                  <ToggleSwitch text="Editar" name="purchase_edit" value={permission.purchase_edit} handleOnChange={() => handleChangeTS("purchase_edit", !permission.purchase_edit)} />
                  <ToggleSwitch text="Excluir" name="purchase_delete" value={permission.purchase_delete} handleOnChange={() => handleChangeTS("purchase_delete", !permission.purchase_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Produção">
              <div className="su-permission-box">
                <img className="su-permission-img" src={cloth} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="production_view" value={permission.production_view} handleOnChange={() => handleChangeTS("production_view", !permission.production_view)} />
                  <ToggleSwitch text="Criar" name="production_create" value={permission.production_create} handleOnChange={() => handleChangeTS("production_create", !permission.production_create)} />
                  <ToggleSwitch text="Editar" name="production_edit" value={permission.production_edit} handleOnChange={() => handleChangeTS("production_edit", !permission.production_edit)} />
                  <ToggleSwitch text="Excluir" name="production_delete" value={permission.production_delete} handleOnChange={() => handleChangeTS("production_delete", !permission.production_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Financeiro">
              <div className="su-permission-box">
                <img className="su-permission-img" src={provider} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="finance_view" value={permission.finance_view} handleOnChange={() => handleChangeTS("finance_view", !permission.finance_view)} />
                  <ToggleSwitch text="Criar" name="finance_create" value={permission.finance_create} handleOnChange={() => handleChangeTS("finance_create", !permission.finance_create)} />
                  <ToggleSwitch text="Editar" name="finance_edit" value={permission.finance_edit} handleOnChange={() => handleChangeTS("finance_edit", !permission.finance_edit)} />
                  <ToggleSwitch text="Excluir" name="finance_delete" value={permission.finance_delete} handleOnChange={() => handleChangeTS("finance_delete", !permission.finance_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Fiscal">
              <div className="su-permission-box">
                <img className="su-permission-img" src={generator} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="fiscal_view" value={permission.fiscal_view} handleOnChange={() => handleChangeTS("fiscal_view", !permission.fiscal_view)} />
                  <ToggleSwitch text="Emitir" name="fiscal_create" value={permission.fiscal_create} handleOnChange={() => handleChangeTS("fiscal_create", !permission.fiscal_create)} />
                  <ToggleSwitch text="Editar Config." name="fiscal_edit" value={permission.fiscal_edit} handleOnChange={() => handleChangeTS("fiscal_edit", !permission.fiscal_edit)} />
                  <ToggleSwitch text="Cancelar" name="fiscal_delete" value={permission.fiscal_delete} handleOnChange={() => handleChangeTS("fiscal_delete", !permission.fiscal_delete)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Backup">
              <div className="su-permission-box">
                <img className="su-permission-img" src={backup} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="backup_view" value={permission.backup_view} handleOnChange={() => handleChangeTS("backup_view", !permission.backup_view)} />
                  <ToggleSwitch text="Fazer Backup" name="backup_create" value={permission.backup_create} handleOnChange={() => handleChangeTS("backup_create", !permission.backup_create)} />
                </div>
              </div>
            </FormSection>

            <FormSection label="Histórico do Sistema">
              <div className="su-permission-box">
                <img className="su-permission-img" src={historic} alt="" />
                <div className="su-toggle-grid">
                  <ToggleSwitch text="Visualizar" name="historic_view" value={permission.historic_view} handleOnChange={() => handleChangeTS("historic_view", !permission.historic_view)} />
                </div>
              </div>
            </FormSection>
          </>
        )}
      </FormLayout>

      <Modal
        modalStatus={modalChangePwd}
        changeStatus={setModalChangePwd}
        w={40}
        h={60}
        content={
          <div className="su-change-pwd">
            <p className="su-change-pwd-title">Digite uma nova senha</p>
            <div className="form-group">
              <Input text="Senha" type="password" name="password" placeholder="Digite a senha" handleOnChange={handleChangeNewPwd} value={newPwd.password || ''} />
            </div>
            <PwdValidationList />
            <div className="form-group">
              <Input text="Confirmar senha" type="password" name="confirmPassword" placeholder="Repita a senha" handleOnChange={handleChangeNewPwd} value={newPwd.confirmPassword || ''} />
            </div>
            <div className="form-group">
              <Button variant="save" onClick={submitChangePwd}>Salvar</Button>
            </div>
          </div>
        }
      />
    </>
  )
}

export default FormSystemUser
